import { Injectable } from '@angular/core';

export type CookieConsent = 'accepted' | 'declined' | null;

@Injectable({ providedIn: 'root' })
export class AnalyticsConsentService {
  private readonly key = 'cookieConsent';

  getConsent(): CookieConsent {
    const v = localStorage.getItem(this.key);
    return v === 'accepted' || v === 'declined' ? v : null;
  }

  hasAnalyticsConsent(): boolean {
    return this.getConsent() === 'accepted';
  }

  setConsent(value: Exclude<CookieConsent, null>): void {
    localStorage.setItem(this.key, value);
  }
}
